// extracted by mini-css-extract-plugin
export default {"card":"BaseCard_card__i8swp"};